const JavascriptData = [
  {
    id: 0,
    imag: "1.jpeg",
    Linko: "https://osos0.github.io/01-Didital_Clock/",
    name: "Didital_Clock",
    price: "$10.50",
  },
  {
    id: 1,
    imag: "2.jpeg",
    Linko: "https://osos0.github.io/34-Weather-App/",
    name: "Weather-App",
    price: "$9.20",
  },
  {
    id: 2,
    imag: "3.jpeg",
    Linko: "https://osos0.github.io/32-local-storge-to-do-list/",
    name: "To-do-list",
    price: "$12.50",
  },
  {
    id: 3,
    imag: "4.jpeg",
    Linko: "https://osos0.github.io/35-Country-Guide-App/",
    name: "Country-Guide",
    price: "$9.20",
  },
  {
    id: 4,
    imag: "5.jpeg",
    Linko: "https://osos0.github.io/08-Vedio-trailer-popup/",
    name: "Trailer-popup",
    price: "$12.50",
  },
  {
    id: 5,
    imag: "6.jpeg",
    Linko: "https://osos0.github.io/-09-Bulurred-Background-Popup/",
    name: "Background-Popup",
    price: "$12.50",
  },
  {
    id: 6,
    imag: "7.jpeg",
    Linko: "https://osos0.github.io/13-Dark-Mode-Toggle/",
    name: "Dark-Mode",
    price: "$12.50",
  },
  {
    id: 7,
    imag: "8.jpeg",
    Linko: "https://osos0.github.io/23-Rotating-image-gallar/",
    name: "Rotating-gallar",
    price: "$12.50",
  },
  {
    id: 8,
    imag: "9.jpeg",
    Linko: "https://osos0.github.io/11-Random-Photos/",
    name: "Random-Photos",
    price: "$12.50",
  },
  {
    id: 9,
    imag: "10.jpeg",
    Linko: "https://osos0.github.io/10-Backgroung-Image-Scroll-Effect/",
    name: "Backgroung-Effect",
    price: "$12.50",
  },
  {
    id: 10,
    imag: "11.jpeg",
    Linko: "https://osos0.github.io/15-Tabes-Section-media/",
    name: "Section-media",
    price: "$12.50",
  },
  {
    id: 11,
    imag: "12.jpeg",
    Linko: "https://osos0.github.io/21-Emoji-Rating/",
    name: "Emoji-Rating",
    price: "$12.50",
  },
  {
    id: 12,
    imag: "13.jpeg",
    Linko: "https://osos0.github.io/11-Drum-Kits/",
    name: "Drum-Kits",
    price: "$12.50",
  },
  {
    id: 13,
    imag: "14.jpeg",
    Linko: "https://osos0.github.io/24-New-Year-countdown/",
    name: "New-Year-countdown",
    price: "$12.50",
  },
  {
    id: 14,
    imag: "15.jpeg",
    Linko: "https://osos0.github.io/25-Random-Password-Generator/",
    name: "Password-Generator",
    price: "$12.50",
  },
  {
    id: 15,
    imag: "16.jpeg",
    Linko: "https://osos0.github.io/26-Animated-search-Bar/",
    name: "Search-Bar",
    price: "$12.50",
  },
  {
    id: 16,
    imag: "17.jpeg",
    Linko: "https://osos0.github.io/27-Social-Media-Selector-Menu/",
    name: "Selector-Menu",
    price: "$12.50",
  },
  {
    id: 17,
    imag: "18.jpeg",
    Linko: "https://osos0.github.io/30-Step-Progress-Bar/",
    name: "Step-Progress",
    price: "$12.50",
  },
  {
    id: 18,
    imag: "19.jpeg",
    Linko: "https://osos0.github.io/04-Real-time-character-counter/",
    name: "Character-counter",
    price: "$12.50",
  },
  {
    id: 19,
    imag: "20.jpeg",
    Linko: "https://osos0.github.io/06-Random-color-Generator/",
    name: "Color-Generator",
    price: "$12.50",
  },
  {
    id: 20,
    imag: "21.jpeg",
    Linko: "https://osos0.github.io/36-Works-Filter/",
    name: "Works-Filter",
    price: "$12.50",
  },
];

export default JavascriptData;
